import React, { Suspense, useState, useEffect, useRef } from "react";
import { withAlert } from "react-alert";
import { Redirect } from "react-router-dom";
import { withTranslation } from "react-multi-lang";
import { Servicecalls, SubMenuRights } from "../../custom_functions/Functions";
import store from "./../../redux_store/store/index";
import { updatecontrolrights } from "../../redux_store/actions";
import ApplicationFooter from "../general/ApplicationFooter";
// import { defalutreduxState, isMultitenant } from "../../custom_functions/Constance";
const Protocols = React.lazy(() => import("./../../custom_modules/Protocols.jsx"));
const SheetCreation = React.lazy(() => import("./../../custom_modules/SheetCreation.jsx"));
let Sheet_Protocol_Rights = false;
const ViewTemplates = () => {
    let ELNurl = (window as any).appUrl.ELN;
    const [Pass_Sessionvalues, setPass_Sessionvalues] = useState<any>("");
    const [Template_Screen, setTemplate_Screen] = useState<String>("");
    const [idle_save, setidle_save] = React.useState<boolean>(false);
    let Screen_Options = "";
    useEffect(() => {
        const Template_Ondata = localStorage.getItem("TemplateNewtab_Open");
        // console.log(Template_Ondata);        
        if (Template_Ondata) {
            const parsedValues = JSON.parse(Template_Ondata);
            if (parsedValues) {
                localStorage.removeItem("TemplateNewtab_Open");
                const { user, packagetype, activeUserId, idletime, newtab, orders } = parsedValues;
                Screen_Options = parsedValues?.screen;
                setPass_Sessionvalues(parsedValues);
                store.getState().Loggeduser = user;
                let Session_Values = parsedValues?.SessionStorage_Copy;
                let Session_Keys = Object.keys(Session_Values);
                if (Session_Keys.length > 0) {
                    Session_Keys?.map((items) => {
                        sessionStorage.setItem(items, Session_Values[items]);
                        return items;
                    })
                }
                sessionStorage.setItem("idletime", idletime);
                sessionStorage.setItem("packagetype", packagetype);
                sessionStorage.setItem("ActiveNewTab", "1");
                if (activeUserId !== undefined && activeUserId !== null) {
                    sessionStorage.setItem("activeUserId", activeUserId);
                }

                redirecttosheetview();
            }
        } else {
            setTemplate_Screen("");
            setPass_Sessionvalues(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const redirecttosheetview = () => {
        let passObjDet = {
            usercode: sessionStorage.getItem("User"),
            lsusergroup: {
                usergroupcode: sessionStorage.getItem("multiusergroups"),
                usergroupname: sessionStorage.getItem("usergroupname"),
            },
        };

        Servicecalls(
            "" + ELNurl + "/User/GetUserRightsonUser",
            passObjDet,
            onUserRightsUpdateSuccess,
            () => { }
        );
    }

    const onUserRightsUpdateSuccess = (res: any) => {
        store.dispatch(updatecontrolrights(res));
        Sheet_Protocol_Rights = SubMenuRights("IDS_MDL_TEMPLATES", Screen_Options === "Sheet_Template" ? "IDS_SCN_SHEETTEMPLATE" : "IDS_SCN_PROTOCOLTEMPLATE");
        setTemplate_Screen(Screen_Options || "");
    }

    const onHandleIdleSave = () => {
        setidle_save(true)
    }

    //  const onlogoutSuccess =(response: any) =>{
    //     store.dispatch(replacestate(defalutreduxState));
    //     setTimeout(() => {
    //       let tenantdomain = sessionStorage.getItem("tenantdomain");
    //       $(".ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable").hide();
    //     //   if (tenantdomain !== undefined) {
    //     //     isMultitenant === 0
    //     //       ? props.history.push("/")
    //     //       : props.history.push("/#" + tenantdomain);
    //     //     this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
    //     //   } else {
    //     //     this.props.history.push("/")
    //     //   }
    //     }, 100);
    //   }

    //  const onlogoutFailure =(response:any) => { }


    let Newtabscreen_Passobject = {
        Isnew_Tabtemplate: true,
        Topassvalueson_Child: Pass_Sessionvalues,
        idle_save: onHandleIdleSave,
        idlesave_newtab: idle_save,
        idletime: Pass_Sessionvalues?.idletime
        // onlogoutSuccess:onlogoutSuccess,
        // onlogoutFailure:onlogoutFailure
    }
    // let screen= {};
    return (
        <>
            <div className="full-screen-spread">


                {Pass_Sessionvalues !== undefined && Template_Screen === "Protocol_Template" && Sheet_Protocol_Rights &&
                    <Suspense fallback={<div></div>}>
                        <Protocols {...Newtabscreen_Passobject} />

                    </Suspense>
                }

                {Pass_Sessionvalues !== undefined && Template_Screen === "Sheet_Template" && Sheet_Protocol_Rights &&
                    <Suspense fallback={<div></div>}>
                        <SheetCreation {...Newtabscreen_Passobject} />

                    </Suspense>
                }

                {Pass_Sessionvalues !== undefined && Template_Screen !== "" && !Sheet_Protocol_Rights &&
                    (!sessionStorage.getItem("tenantdomain") ?
                        <Redirect to="/" /> :
                        <Redirect to={"/#" + sessionStorage.getItem("tenantdomain")} />
                    )
                }

                {Pass_Sessionvalues === undefined && Template_Screen === "" &&
                    <Suspense fallback={<div></div>}>
                        <Redirect to="/" />
                    </Suspense>
                }

                {/* {Pass_Sessionvalues !== undefined && Template_Screen === "Protocol_Template" ?
                    < Protocols
                        {...Newtabscreen_Passobject}
                    />
                    : Pass_Sessionvalues !== undefined && Template_Screen === "Sheet_Template" ?
                        <SheetCreation   {...Newtabscreen_Passobject} /> :
                        Pass_Sessionvalues === undefined && !sessionStorage.getItem("tenantdomain") && Template_Screen !== "" ?
                            <Redirect to="/" />
                            : Pass_Sessionvalues === undefined && Template_Screen !== "" ?
                                <Redirect to={"/#" + sessionStorage.getItem("tenantdomain")} /> : Pass_Sessionvalues === undefined && Template_Screen === undefined ? <Redirect to="/" /> : false

                } */}
                <Suspense fallback={<div></div>}>
                    <ApplicationFooter
                        {...Newtabscreen_Passobject}
                    />
                </Suspense>
            </div>
        </>
    )
}
export default withAlert()(withTranslation(ViewTemplates));